import { IApplicationState, TBoardId } from '../../../types/types';
import { IBoardUserMeta } from 'app/store/model/boardUserMeta/types';
import { getBoardUserMeta } from 'app/store/model/boardUserMetas/selectors/getBoardUserMeta';

export const getBoardUserMetaForRollback = (
    state: IApplicationState,
    boardId: TBoardId,
    patchBoardUserMeta: IBoardUserMeta
): IBoardUserMeta => {
    const meta = getBoardUserMeta(state, boardId);
    if (!patchBoardUserMeta) return;

    let metaForRollback: IBoardUserMeta = {};

    for (const field in patchBoardUserMeta) {
        const fieldKey = field as keyof IBoardUserMeta;
        metaForRollback = {
            ...metaForRollback,
            [fieldKey]: meta[fieldKey]
        };
    }

    return JSON.parse(JSON.stringify(metaForRollback));
}
